import React from "react";

import InputSearch from '../../atoms/search';
import Table from '../../blocks/table';
import {FormikProvider} from '../../formik/formik.context'
import HeaderUsers from "../../Menu/MenuAdministration/HeaderUsers";

import {getTableRows,tableHead} from './helpers';
import {useGetRequests} from './hooks'
import * as Styled from './styled';

export default function Requests() {
  const {dataRows, onGetRequests, onPostRequestFind} = useGetRequests();

  const rows = getTableRows(
    dataRows,
    onGetRequests
  );

  const handleChangeSearchRequest = (event) => {
    onPostRequestFind(event.target.value)
  }

  return (
    <FormikProvider >
      <HeaderUsers />
      <Styled.Section>
        <Styled.SectionHead
          jContent={'space-between'}
          widthItem={[465, 170]}
        >
          <InputSearch
            placeholder={'Поиск'}
            onChange={handleChangeSearchRequest}
          />
        </Styled.SectionHead>
        <Table
          head={tableHead}
          data={rows}
          class={'table'}
        />
      </Styled.Section>

    </FormikProvider>
  );
}
